import React from "react";
import { Input, Form } from "antd";

const FormFields = () => {

  return (
    <>
      <Form.Item
        name="firstName"
        label="Prénom"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer le prénom",
          },
        ]}
      >
        <Input placeholder="Prénom" />
      </Form.Item>
      <Form.Item
        name="lastName"
        label="Nom de famille"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer le nom de famille",
          },
        ]}
      >
        <Input placeholder="Nom de famille" />
      </Form.Item>
      <Form.Item
        name="email"    
        label="email"
        rules={[
          {
            required: true,
            type: "email",
            message: "S'il vous plaît entrer un email valide",
          },
        ]}
      >
        <Input placeholder="Email" />
      </Form.Item>
      <Form.Item
        name="phone"
        label="Téléphone"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer le numéro de téléphone",
          },
        ]}
      >
        <Input placeholder="Téléphone" />
      </Form.Item>
      <Form.Item
        name="adresse"
        label="Adresse"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer l'adresse",
          },
        ]}
      >
        <Input placeholder="adresse" />
      </Form.Item>
      <Form.Item
        name="password"
        label="Mot de passe"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer le mot de passe",
          },
        ]}
      >
        <Input.Password placeholder="mot de passe" />
      </Form.Item>
    </>
  );
};

export default FormFields;
